import { UpdateAppVersionParams } from "../interfaces/mobile-app-alerts-interface";
import axiosInstance from "../utils/axios-instance";

export const getAppVersion = async (appPackageName: string) => {
  const response = await axiosInstance.get(
    `${process.env.REACT_APP_API_BASE_URL}/cms/mobile-version/${appPackageName}`
  );
  return response.data;
};

export const updateAppVersion = async (
  appVersionData: UpdateAppVersionParams
) => {
  const response = await axiosInstance.post(
    `${process.env.REACT_APP_API_BASE_URL}/cms/mobile-version`,
    appVersionData
  );
  return response.data;
};
